import dayjs from "dayjs";
import { IFirstBoarding } from "../../interfaces/endpoints/IBoarding.types";

// A repeat from this phone may be a retry whose answer was lost or a copy of the QR; the card says it was
// this phone and how long ago, and the driver judges by who is standing there.
export const firstScanText = (first: IFirstBoarding, shownAt: number) => {
  const time = dayjs(first.at).format("HH:mm");
  if (!first.bySameScanner) {
    return `Skanuar në orën ${time}${first.scannedByName ? ` nga ${first.scannedByName}` : ""}`;
  }
  const seconds = Math.max(0, Math.round((shownAt - dayjs(first.at).valueOf()) / 1000));
  if (seconds < 10) return "Skanuar tani nga ky telefon";
  if (seconds < 60) return `Skanuar nga ky telefon para ${seconds} sekondash`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 10) return `Skanuar nga ky telefon para ${minutes} ${minutes === 1 ? "minute" : "minutash"}`;
  return `Skanuar nga ky telefon në orën ${time}`;
};
